/* globals Stripe  */
const axios = require('axios')

function retryFailedRequest (err) {
  if (err.status === 502 && err.config && !err.config.__isRetryRequest) {
    err.config.__isRetryRequest = true
    return axios(err.config)
  }
  throw err
}

class PremiumApi {

  constructor (config) {
    this.updateConfig(config)
  }

  updateConfig (_config) {
    const config = Object.assign({}, this.config, _config)
    const { client, version, authToken, apiKey, root } = config

    if (client) {
      this.client = client
    } else {
      this.client = axios.create({
        baseURL: `${root}/v${version}`,
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json',
          'Domain': 'mmf',
          'X-Requested-With': 'XMLHttpRequest',
          'mfp-client-id': apiKey,
        },
      })
      this.client.interceptors.response.use(undefined, retryFailedRequest)
    }

    this.config = config
  }

  getStripeToken (card) {
    return new Promise((resolve, reject) => {
      Stripe.card.createToken(card, (status, response) => {
        if (response.error) {
          reject(response.error.message)
        } else {
          resolve(response.id) // id is the Stripe token
        }
      })
    })
  }

  getBillingProfiles () {
    return this.client.get('/billing-profiles')
  }

  patchBillingProfile ({ id, data }) {
    return this.client.patch(`/billing-profiles/${id}`, data)
  }

  patchDefaultBillingProfile ({ id, profile }) {
    const newProfile = { ...profile, default: true }
    return this.patchBillingProfile({ id, data: { item: newProfile }})
  }

  postBillingProfile ({ provider, token }) {
    return this.client.post('/billing-profiles', {
      item: {
        payment_provider: provider,
        cc_token: token,
      },
    })
  }

  getPaidSubscriptions () {
    return this.client.get('/paid-subscriptions')
  }

  postPaidSubscription ({ product, coupon, provider, countryCode }) {
    return this.client.post('/paid-subscriptions', {
      item: {
        product_id: product.product_id,
        billing_details: {
          coupon,
          country_code: ('US' || countryCode).toUpperCase(), // TODO: Until SKUs are updated - WWW-1999
          payment_provider: provider,
        },
      },
    })
  }

  updatePaidSubscription ({ subscriptionId, data }) {
    return this.client.patch(`/paid-subscriptions/${subscriptionId}`, data)
  }

  updateAutoRenewal ({ subscriptionId, autoRenewal }) {
    return this.updatePaidSubscription({
      subscriptionId,
      data: {
        item: {
          requested_cancellation: !autoRenewal,
        },
      },
    })
  }

  disableAutoRenewal (subscriptionId) {
    return this.updateAutoRenewal({ subscriptionId, autoRenewal: false })
  }

  getCoupon (couponCode) {
    return this.client.get(`/coupons/${couponCode}`)
  }

  getProduct (productId) {
    return this.client.get(`/products/${productId}`)
  }

  getUserCoupons () {
    return this.client.get('/user-coupons')
  }

  postUserCoupon ({ couponCode, userId, countryCode }) {
    return this.client.post('/user-coupons', {
      item: {
        user_id: `${userId}`,
        coupon_id: couponCode,
        country_code: ('US' || countryCode).toUpperCase(), // TODO: Until SKUs are updated - WWW-1999
      },
    })
  }

  deleteBillingProfile (profileId) {
    return this.client.delete(`/billing-profiles/${profileId}`)
  }

  patchUserCoupon (couponId, data) {
    return this.client.patch(`/user-coupons/${couponId}`, data)
  }

  redeemCoupon (coupon) {
    return this.patchUserCoupon(coupon, {
      item: {
        redeemed: true,
      },
    })
  }

}

module.exports = PremiumApi
